export const tanksCases = {
    TANKS_INPUTS: 'TANKS_INPUTS',
    GET_TANKS: 'GET_TANKS',
    FILTER_TANKS: 'FILTER_TANKS',
    CREATE_TANK: 'CREATE_TANK',
    EDIT_TANK: 'EDIT_TANK',
    DELETE_TANK: 'DELETE_TANK',
    GET_TANK_SUPPLY_PERMIT: 'GET_TANK_SUPPLY_PERMIT',
    CREATE_TANK_SUPPLY_PERMIT: 'CREATE_TANK_SUPPLY_PERMIT',
    ADD_TANK_SUPPLY_PERMIT: 'ADD_TANK_SUPPLY_PERMIT',
    DELETE_TANK_SUPPLY_PERMIT: 'DELETE_TANK_SUPPLY_PERMIT'
}